var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"py-2 my-2 mx-1"},[_vm._v(" "+_vm._s(_vm.file.name)+" "),_c('v-btn',{attrs:{"loading":_vm.loading,"fab":"","icon":"","color":"primary"},on:{"click":_vm.delete_file}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }